import type { TAuth, TSlackMessage } from "@/types"
import { isDev } from "@/utils/env"
import { api } from "./api"
import { generateAPIResource } from "./utils"

export async function slackAPIAuthorize({
  code,
  state,
  mode = "login",
}: {
  code: string
  state: string
  mode?: "login" | "register"
}) {
  const url = `/slack/auth?mode=${mode}${isDev ? "&dev=1" : ""}`
  const { data } = await api.post(url, { code, state })
  return data as TAuth
}

export async function fetchAPISlackTeam() {
  const { data } = await api.get(`/slack/team`)
  return data
}

export async function fetchAPISlackChannels() {
  const res = await api.get("/slack/channels")
  return res.data as any[]
}

export const slackMessagesAPI = generateAPIResource<TSlackMessage>("/slack/messages", {
  create: true,
  update: false,
  remove: true,
})
